import React from 'react'
import { FaHeart, FaShare } from 'react-icons/fa6'

function JoinUS() {

    const donationClick =()=>{
        const menu_dropdown = document.querySelector(".donate_header")
        menu_dropdown.classList.toggle("donate_dropDown");
    }

  return (
    <div className='about_sub' >
        <div className='about_sub_header'>
            <div className='about_sub_header_line'></div>
            <h2>PARTNER WITH US</h2>
        </div>
        
        <div className='joinus_container'>
            <div className='joinus_container_write_ups'>
                <h1>BE A PART OF THE CHANGE</h1>
                <p>
                    The Lord Nations Foundation, we believe that every helping 
                    hand makes a difference in the lives of the less privileged. 
                    You can join us in various ways to bring hope, support, and opportunities to those in need.
                </p>
                
                <div className='joinus_container_write_ups_btns' >
                    <div onClick={donationClick} className='joinus_container_btn fstjoinus_container_btn' >
                        <p>DONATE</p>
                        <FaHeart className='desk_header_donate_btn_icon' />
                    </div>

                    <div className='joinus_container_btn secjoinus_container_btn' >
                        <p>Spread the Word </p>
                        <FaShare/>
                    </div>
                </div>

                <small>Join us today and be a ray of hope in someone's life</small>
            </div>

            <div className='joinus_container_img' ></div>
        </div>
    </div>
  )
}

export default JoinUS